import { IMAGE_ALT } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import React from 'react';
import { Link } from 'react-router-dom';
import './SFPInfo.css';

const SFPInfo: React.FC = () => {
  const benefits = [
    'Clear, Transparent Pricing',
    'Maintain Your Prime Badge',
    'Reliable On-Time Dispatch',
    'Low Cancellation Rates',
    'Amazon Buy Shipping Integration',
    'Competitive UK Shipping Rates'
  ];

  return (
    <section className="sfp-info-section">
      <div className="sfp-info-container">
        <div className="sfp-info-content">
          {/* Left Side - Image */}
          <div className="sfp-info-image-wrapper">
            <PictureImage width={2000} height={2000} 
              src="/Images/shopifyFulfilment.webp" 
              alt={IMAGE_ALT.sfpInfoGraphic} 
              className="sfp-info-image" loading="lazy" />
          </div>
          
          {/* Right Side - Text */}
          <div className="sfp-info-text">
            <div className="sfp-info-badge">
              <span className="sfp-info-badge-dot"></span>
              SFP
            </div>
            <h2 className="sfp-info-title">Amazon Seller Fulfilled Prime UK: How Our SFP Service Works</h2>
            <p className="sfp-info-description">
              Our Amazon Seller Fulfilled Prime UK service helps sellers maintain Prime eligibility while keeping
              complete control of inventory and fulfilment. Ideal for oversized or slow-moving products, it pairs
              with <Link to="/fulfillment-by-merchant-services">Amazon FBM fulfilment</Link> and optional{' '}
              <Link to="/amazon-fba-prep-services">FBA prep services</Link> when you still need FC inbound —
              helping reduce long-term storage fees (see our{' '}
              <Link to="/blog/sfp-vs-fba-2026">SFP vs FBA 2026</Link>{' '}
              comparison).
            </p>
            
            {/* Benefits List */}
            <div className="sfp-info-benefits">
              {benefits.map((benefit, index) => (
                <div key={index} className="sfp-info-benefit-item">
                  <div className="sfp-info-benefit-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10 5V15M5 10H15" stroke="#28479e" strokeWidth="2.5" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <span className="sfp-info-benefit-text">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SFPInfo;
